module.exports = __webpack_public_path__ + "b9d1ffa32852b94f79c15196330d2502.jpg";